@if(product(); as product) {
<div
    class="ca-product-tile ca-text-md"
    [class.is-different-product-type]="isDifferentProductType()"
    [class.is-selected]="isSelected()"
    (click)="selectProduct.emit(product)"
>
    <div class="ca-product-tile-media">
        <img alt="{{ product.productName }}" [src]="product.pictureUrl || placeholderImageSrc" />
    </div>

    <div class="ca-product-tile-body">
        <div class="flex flex-col md:flex-row items-center gap-2">
            <div class="font-semibold">{{ product.productName }}</div>
            <!-- TODO: Uncomment when API ready -->
            <!-- <ca-tag type="green" [outline]="true" [rounded]="true">
                {{ 'CA.LABEL.RECOMMENDATION' | translate }}
            </ca-tag> -->
        </div>

        <div class="ca-product-tile-meta">
            <div>
                <div class="ca-text-tertiary">{{ 'CA.PRODUCT_TILE.ARTICLE_NR' | translate }}</div>
                <div class="ca-text-primary">{{ product.id }}</div>
            </div>
            @for(spec of product | caProductTechnicalData | slice:0:1; track spec.name) {
            <div>
                <div class="ca-text-tertiary">{{ spec.name | translate }}</div>
                <div class="ca-text-primary">
                    {{ spec.value ?? '-' }}
                    @if(spec.unit) {
                    <span>
                        {{ spec.unit | translate }}
                    </span>
                    }
                </div>
            </div>
            }
            <div>
                <div class="ca-text-tertiary">{{ 'CA.PRODUCT_TILE.TYPE' | translate }}</div>
                <div class="ca-text-primary">{{ 'CA.DEVICE_TYPE.' + product.productType | translate }}</div>
            </div>
            <div>
                <div class="ca-text-tertiary">{{ 'CA.PRODUCT_TILE.PRICE' | translate }}</div>
                <div class="ca-text-primary">{{ product.price | caCurrency : countryCode() : languageCode() }}</div>
            </div>
        </div>
    </div>

    <div class="ca-product-tile-action">
        <button
            mat-stroked-button
            class="ca-button ca-button-s"
            [disabled]="isDifferentProductType()"
            (click)="selectProduct.emit(product); $event.stopPropagation()"
        >
            @if(isSelected()) {
            <mat-icon>check</mat-icon>
            }
            <span>{{ (isSelected() ? 'CA.BUTTON.SELECTED' : 'CA.BUTTON.SELECT') | translate }}</span>
        </button>
    </div>
</div>
}
